export enum FirstLoginStep {
  License = 0,
  Password = 1,
  PhoneNumber = 2,
  PhoneConfirmation = 3,
  ContactEmail = 4,
  ContactEmailConfirmation = 5,
  ContactEmailSuccess = 6,
  Speciality = 7,
  Templates = 8,
  Done = 9,
}

export enum OptionalStepState {
  NotStarted = 'notStarted',
  Completed = 'completed',
  Skipped = 'skipped',
}

export interface PasswordStepData {
  valid: boolean;
  currentPassword: string;
  newPassword: string;
  verifyPassword: string;
}

export interface PhoneStepData {
  state: OptionalStepState;
  phoneNumber: string;
  countryCode: string;
  verificationSentAt: Date | null;
  confirmationShown: boolean;
}

export interface EmailStepData {
  state: OptionalStepState;
  email: string;
  verificationSentAt: Date | null;
  confirmationShown: boolean;
  isVerified: boolean;
}

export interface SpecialityStepData {
  state: OptionalStepState;
  speciality: string;
}

export interface TemplatesStepData {
  state: OptionalStepState;
  selectedTemplates: { id: number; type: string }[];
}

export interface FirstLoginData {
  licenseAgreed: boolean;
  password: PasswordStepData;
  phone: PhoneStepData;
  email: EmailStepData;
  speciality: SpecialityStepData;
  templates: TemplatesStepData;
}

export interface CountryCode {
  name: string;
  code: string;
  dialCode: string;
  flag: string;
}
